var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "450"
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    staticClass: "v-card--dialog rounded-xl"
  }, [_c('div', {
    staticClass: "v-card--dialog__head"
  }, [_c('h3', {
    staticClass: "tit tit--xs"
  }, [_vm._v("현금영수증 발급 안내")]), _c('v-btn', {
    staticClass: "v-card--dialog__close",
    attrs: {
      "fab": "",
      "color": "transparent"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-divider', {
    staticClass: "grey lighten-1 mt-10px"
  }), _c('v-card-text', [_vm._v(" - 현금성 결제수단으로 10원 이상 결제시 발급 가능합니다. ")]), _c('v-card-text', [_vm._v(" - 현금영수증 발행 신청 가능 결제수단 : 캐시결제 ")]), _c('v-card-text', [_vm._v(" - 현금영수증 의무발행제도 시행으로, 현금성 결제금액 10만원 이상은 현금영수증이 신청과 무관하게 무조건 발행됩니다. ")]), _c('v-card-text', [_vm._v(" - 본인 외 타인 명의로 신청 가능합니다. ")]), _c('v-card-text', [_vm._v(" - 현금영수증은 결제한 익일 국세청에 신고 되어 2~3일 내에 발행내역을 확인 할 수 있습니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }